import { Moon, Sun } from 'lucide-react';
import { useTheme } from 'ui/theme/ThemeContext';

/** Alterna entre el tema claro y el oscuro; la elección queda guardada en el navegador. */
export const ThemeToggle = () => {
	const { theme, setTheme } = useTheme();
	const dark = theme === 'dark';
	const label = dark ? 'Modo claro' : 'Modo oscuro';

	return (
		<button
			type="button"
			onClick={() => setTheme(dark ? 'default' : 'dark')}
			aria-label={label}
			title={label}
			className="text-foreground hover:bg-accent focus-visible:outline-ring flex h-9 w-9 cursor-pointer items-center justify-center rounded-sm transition-colors focus-visible:outline-2">
			{dark ? (
				<Sun
					size={18}
					aria-hidden="true"
				/>
			) : (
				<Moon
					size={18}
					aria-hidden="true"
				/>
			)}
		</button>
	);
};
